//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FCImage from '~/components/FCImage.vue';
import { careerTeammates } from '~/constants/teammates';

export default {
  name: 'Careers_Teammates',
  components: {
    FCImage,
  },
  data: () => ({
    teammates: careerTeammates,
  }),
};
